import types from './types';
import {
  getUser,
  login as _login,
  logout as _logout,
  validateApplicationRole as _validateApplicationRole,
  clearCache as _clearCache,
} from '@/core/auth';
import { ACR_VALUES } from '@/config';
import {
  getUserMenu,
  getAdditionalProfileInfo,
} from '@/services/common/user.api.js';
import { USER_MENU_APP_SESSION_KEY } from '@/config';

export default {
  async init(context) {
    const { state, commit, dispatch } = context;

    try {
      const user = await getUser(); //This always call for refresh token information.
      commit(types.SET_USER, user);

      sessionStorage.setItem('user', JSON.stringify(user));

      if (state.userHasValidRole === null) {
        const hasValidRole = await _validateApplicationRole().then((resp) => {
          return resp;
        });

        if (!hasValidRole) {
          this.logout({ state, dispatch });
          return;
        }

        commit(types.SET_USER_HAS_VALID_ROLE, hasValidRole);

        sessionStorage.setItem(
          'user-has-valid-role',
          JSON.stringify(hasValidRole)
        );
      }

      if (
        state.user &&
        (!state.userMenu || !state.companies || !state.permissions)
      ) {
        const [userMenu, additionalProfileInfo] = await Promise.all([
          await getUserMenu(),
          await getAdditionalProfileInfo(),
        ]);

        if (userMenu && userMenu.length) {
          commit(types.SET_MENU, userMenu);
          sessionStorage.setItem(
            USER_MENU_APP_SESSION_KEY,
            JSON.stringify(userMenu)
          );
          context.dispatch('$_common/getCurrentAcademicYear', null, {
            root: true,
          });
        }

        if (additionalProfileInfo) {
          const { companies, permissions, userProfile } = additionalProfileInfo;

          //Set User Information
          commit(types.SET_PROFILE, userProfile);
          commit(types.SET_COMPANIES, companies);
          sessionStorage.setItem('user-profile', JSON.stringify(userProfile));
          sessionStorage.setItem('user-companies', JSON.stringify(companies));

          commit(types.SET_PERMISSIONS, permissions);
          sessionStorage.setItem(
            'user-permissions',
            JSON.stringify(permissions)
          );
        }
      }
    } catch {
      commit(types.SET_USER, null);
      commit(types.SET_USER_HAS_VALID_ROLE, null);
      commit(types.SET_PERMISSIONS, null);
      sessionStorage.removeItem('user-has-valid-role');
      sessionStorage.removeItem('user-permissions');
    }
  },
  async clearSession({ commit }) {
    commit(types.SET_USER_HAS_VALID_ROLE, null);

    sessionStorage.removeItem(USER_MENU_APP_SESSION_KEY);
    sessionStorage.removeItem('user-permissions');
    sessionStorage.removeItem('user-companies');
    sessionStorage.removeItem('current-academic-year');
    sessionStorage.removeItem('user-has-valid-role');
    sessionStorage.removeItem('user-is-Logging-out');

    sessionStorage.clear();
    await _clearCache();
  },
  login() {
    _login();
  },
  logout({ state, dispatch }) {
    // commit(types.SET_USER_HAS_VALID_ROLE, null);

    // sessionStorage.removeItem('user-menu');
    // sessionStorage.removeItem('user-permissions');
    // sessionStorage.removeItem('user-companies');
    // sessionStorage.removeItem('current-academic-year');
    // _logout();

    _logout();
    dispatch('clearSession').then(function() {
      /* Señor FORCE */
      let urlLogout = process.env.VUE_APP_URL_AUTH;
      urlLogout += process.env.VUE_APP_ACR_URL_LOGOUT;
      urlLogout += '/?logoutid=' + state.user.profile.sub;
      urlLogout +=
        '&redirectUrl=' + process.env.VUE_APP_URL_AUTH_POST_LOGOUT_REDIRECT_URI;
      urlLogout += '&tenant=' + ACR_VALUES.split(':')[1];

      window.location.replace(urlLogout);
    });

    // Validar como hacer logout sin enviar tantos parametros y de la forma adecuada -_- :/
  },
  async validateRole({ state }) {
    if (state.user.hasValidRole === undefined) {
      const userId = state.user.sub;
      await _validateApplicationRole(userId);
    }
  },
};
